import { QueryKeys } from "@/constants/Query";
import axiosInstance from "@/lib/axios";
import { useInfiniteQuery } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

export interface FilesPaging {
  page: number;
  pageSize: number;
  hasNext: boolean;
  hasPrev: boolean;
  nextPage: number | null;
  prevPage: number | null;
}

export interface FilesResponse {
  files: fhirTypes.DocumentReference[];
  paging?: FilesPaging;
}

export interface FilesParams {
  patientId: string;
  categories?: string;
  pageSize?: number;
}

export const DEFAULT_PAGE_SIZE = 10;

export const useFiles = ({
  patientId,
  categories,
  pageSize = DEFAULT_PAGE_SIZE,
}: FilesParams) => {
  return useInfiniteQuery<FilesResponse>({
    queryFn: async ({ pageParam }) => {
      const response = await axiosInstance.get<FilesResponse>(
        "/charting/files/",
        {
          params: {
            patientId,
            categories,
            page: pageParam,
            pageSize: pageSize,
          },
        },
      );

      return response.data;
    },
    queryKey: QueryKeys.Patient.MedicalRecords.Files.DEFAULT(
      patientId,
      categories,
    ),
    enabled: !!patientId,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage.paging?.hasNext) return lastPage.paging.nextPage;
      return undefined;
    },
  });
};
